import React, { useState } from 'react'
import { Box, IconButton, Modal, Typography, Link, Button, Tooltip } from '@mui/material'
import { CopyClipboardIcon } from '../../../Assets/Images/svgs'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import ErrorIcon from '@mui/icons-material/Error'
import mainApiService from '../../../Services'
import { PARAMETER_MANAGEMENT_CRUD } from '../../../Constants/ApiDefinations'
import { useAppDispatch } from '../../../Store/Hooks'
import { setLoader } from '../../../Store/Slice/loader.slice'
import { useNavigate } from 'react-router-dom'
import { PAGES_ROUTES } from '../../../Constants'
import { CloneListingIcon, RedirectIcon } from '../../Icons'
import {
  disableButtonBasedOnRole,
  getItemIdValue,
  handleResponse,
  openLinkInNewTab,
} from '../../../Helpers/Util'
import { showAlert } from '../../../Store/Slice/alert.slice'
import MUISelectWithoutControl from '../MUI-Select-Without-Control'
import MUICheckbox from '../MUI-Checkbox'
import { NOTIFICATION_MODULE } from '../../../Constants/Constant'

type clonePropBase = {
  cloneSegmemtIdNodeForApiPayload?: never
  apiMidPoint?: never
  redirectViewAPiRouteMidPoint?: string
  titleNodeToDisplay: string
  title?: string
  isCloneDisabled?: boolean
  openInNewTab?: boolean
  layout?: string
}
type clonePropClonable = {
  cloneSegmemtIdNodeForApiPayload: string
  apiMidPoint: string
  redirectViewAPiRouteMidPoint: string
  titleNodeToDisplay: string
  title?: string
  isCloneDisabled?: boolean
  openInNewTab?: boolean
  layout?: string
}
type cloneProp = clonePropBase | clonePropClonable
interface CloneModalProps {
  id: string
  onCancel?: (value: boolean) => void
  cloneProps?: cloneProp
  open?: boolean
  showCloneIcon?: boolean
}

const CloneModal: React.FC<CloneModalProps> = ({
  id,
  cloneProps,
  onCancel,
  open,
  showCloneIcon = true,
}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [openCloneModal, setOpenCloneModal] = useState(open ?? false)
  const [openClonedModal, setOpenClonedModal] = useState(false)
  const [openFailedModal, setOpenFailedModal] = useState(false)
  const [error, setError] = useState<string>('')
  const [numberOfClones, setNumberOfClones] = useState(1)
  const [isSwitchToLayout, setIsSwitchToLayout] = useState(false)
  const [clonedItems, setClonedItems] = useState<any[]>([])

  const handleCloneClick = (e: React.MouseEvent) => {
    e.preventDefault()
    setOpenCloneModal(true)
  }
  const handleCloneSubmit = async () => {
    try {
      const data: any = {
        [`${cloneProps?.cloneSegmemtIdNodeForApiPayload}`]: id,
        noOfCopies: numberOfClones,
        isSwitchToLayout: isSwitchToLayout,
      }
      if (isSwitchToLayout) {
        data.layout =
          cloneProps?.layout === NOTIFICATION_MODULE.PORTRAIT
            ? NOTIFICATION_MODULE.LANDSCAPE
            : NOTIFICATION_MODULE.PORTRAIT
      }
      const requestedData: any = PARAMETER_MANAGEMENT_CRUD.CLONE_PARAMETER(
        data,
        cloneProps?.apiMidPoint,
      )
      const result = await mainApiService(requestedData)
      const { message, error } = handleResponse(result)
      if (error) {
        setOpenCloneModal(false)
        setOpenFailedModal(true)
        dispatch(showAlert([true, message, 'error']))
      } else {
        dispatch(setLoader(false))
        dispatch(showAlert([true, message, 'success']))
        setOpenCloneModal(false)
        setOpenClonedModal(true)
        setClonedItems(result?.data)
      }
    } catch (error: any) {
      console.error('Error cloning items:', error)
      setError('Error cloning items')
    }
  }

  const isCloneDisabled = cloneProps?.isCloneDisabled || false
  const options = Array.from({ length: 10 }, (_, i) => ({ value: i + 1, label: i + 1 }))
  const handleCancel = () => {
    setOpenClonedModal(false)
    if (onCancel) {
      onCancel(true)
    }
  }

  const pathArray = window.location.pathname.split('/')
  const moduleAccess = disableButtonBasedOnRole(pathArray[1])

  const handleCheckboxChange = () => {
    const checked = !isSwitchToLayout
    setIsSwitchToLayout(checked)
    if (checked) {
      setNumberOfClones(1)
    }
  }
  const showLayoutCheckbox =
    cloneProps?.layout === NOTIFICATION_MODULE.PORTRAIT ||
    cloneProps?.layout === NOTIFICATION_MODULE.LANDSCAPE

  return (
    <>
      {showCloneIcon && (
        <Tooltip
          title={
            isCloneDisabled ? `Add 'Title' parameter to clone this ${cloneProps?.title ?? ''}` : ''
          }
          arrow
          disableInteractive={!isCloneDisabled}
        >
          <span>
            <IconButton
              data-testid={isCloneDisabled ? 'disabledCloneBtn' : 'enabledCloneBtn'}
              onClick={handleCloneClick}
              disabled={moduleAccess || isCloneDisabled}
              className={moduleAccess || isCloneDisabled ? 'disabled' : ''}
            >
              <CloneListingIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {/* Clone Modal */}
      <Modal open={openCloneModal} onClose={() => setOpenCloneModal(false)}>
        <Box sx={{ ...modalStyle, height: 'max-content' }}>
          <div className='clone-icon'>
            <CopyClipboardIcon />
          </div>
          <Typography variant='h6'>Clone {cloneProps?.title ? cloneProps?.title : ''}</Typography>
          <Typography style={{ paddingBottom: 30, fontSize: 13 }}>
            Enter the number of clones you want to create for this{' '}
            {cloneProps?.title ? cloneProps?.title : ''}
          </Typography>
          <MUISelectWithoutControl
            sx={{ height: '48px' }}
            lable={`No. of Clone ${cloneProps?.title ? cloneProps?.title : ''}`}
            options={options}
            value={numberOfClones}
            onChange={(value: React.SetStateAction<number>) => setNumberOfClones(value)}
            noClear
            disabled={isSwitchToLayout}
          />
          {(cloneProps?.layout === NOTIFICATION_MODULE.PORTRAIT ||
            cloneProps?.layout === NOTIFICATION_MODULE.LANDSCAPE) && (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, mt: 2 }}>
                <MUICheckbox
                  label={
                    <span
                      style={{
                        fontSize: 14,
                        color: '#6A6C6D',
                      }}
                    >
                      {cloneProps.layout === NOTIFICATION_MODULE.PORTRAIT
                        ? 'Switch to Landscape Layout'
                        : 'Switch to Portrait Layout'}
                    </span>
                  }
                  checked={isSwitchToLayout}
                  handleChange={handleCheckboxChange}
                  size='medium'
                  name='switch-layout'
                />
              </Box>
              <Box
                sx={{
                  background: '#ECE9F2',
                  borderRadius: '8px',
                  padding: '10px 16px',
                  display: 'flex',
                  alignItems: 'center',
                  height: '50px',
                }}
              >
                <ErrorIcon sx={{ color: '#402080', fontSize: 20, mr: 1 }} />
                <Typography sx={{ color: '#402080', fontWeight: 500, fontSize: 14 }}>
                  Note: Images will not be cloned.
                </Typography>
              </Box>
            </>
          )}
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              gap: 2,
              height: '44px',
              mt: showLayoutCheckbox ? 3 : 4,
            }}
          >
            <Button
              variant='outlined'
              fullWidth
              onClick={() => {
                setOpenCloneModal(false)
                setIsSwitchToLayout(false)
                setNumberOfClones(1)
                if (!showCloneIcon) onCancel?.(true)
              }}
              className='clone-modal-text'
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              fullWidth
              onClick={handleCloneSubmit}
              className='clone-modal-text'
              data-testid='clone-modal__submit'
              disabled={moduleAccess}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
      {error && (
        <div className='mt-1 text-left' data-testid='parentId-json__error'>
          <div className='d-flex col37 paragraph-6'>
            <ErrorOutlineOutlinedIcon
              sx={{ color: '#d4351c', fontSize: '1.25rem', marginRight: '.675rem' }}
            />{' '}
            {error}
          </div>
        </div>
      )}
      {/* Cloned Items Modal */}
      <Modal open={openClonedModal} onClose={() => setOpenClonedModal(false)}>
        <Box
          sx={{ ...modalStyle, maxHeight: 411 }}
          overflow={clonedItems?.length > 4 ? 'scroll' : 'auto'}
        >
          <div className='clone-icon'>
            <CopyClipboardIcon />
          </div>
          <Typography variant='h6'>Cloned {cloneProps?.title ? cloneProps?.title : ''}</Typography>
          <Typography className='cloned-text'>
            The {cloneProps?.title ? cloneProps?.title : ''} has been successfully cloned. Below are
            the links to the cloned {cloneProps?.title ? cloneProps?.title : ''}
          </Typography>
          <h5 className='cloned-title'>
            List of Cloned {cloneProps?.title ? cloneProps?.title : ''}
          </h5>
          {clonedItems?.map((item, index) => (
            <Typography key={getItemIdValue(item)} className='clone-list'>
              <Link
                onClick={() => {
                  const baseUrl = `/${PAGES_ROUTES.BoltMasterNew}/${cloneProps?.redirectViewAPiRouteMidPoint}/view/${item._id}`
                  const fallbackUrl = `/${cloneProps?.redirectViewAPiRouteMidPoint}/view/${item._id}`

                  if (cloneProps?.openInNewTab) {
                    openLinkInNewTab(fallbackUrl)
                  } else {
                    navigate(baseUrl)
                  }
                }}
              >
                <span>
                  {`${index + 1}. `}
                  {item[cloneProps?.titleNodeToDisplay ?? '']}
                </span>
                <RedirectIcon />
              </Link>
            </Typography>
          ))}
          <Box mt={4}>
            <Button
              variant='outlined'
              className='clone-modal-text'
              fullWidth
              onClick={handleCancel}
              data-testid='cloned-modal__cancel'
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={openFailedModal} onClose={() => setOpenFailedModal(false)}>
        <Box sx={{ ...modalStyle, height: 200 }}>
          <ErrorIcon style={{ fill: '#D4351C' }} />
          <Typography variant='h6'>
            Cloning of {cloneProps?.title ? cloneProps?.title : 'item'} Failed
          </Typography>

          <Box mt={4}>
            <Button
              variant='outlined'
              className='cloned-btn'
              fullWidth
              onClick={() => {
                setOpenFailedModal(false)
                window.location.reload()
              }}
              disabled={moduleAccess}
            >
              Reload
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  )
}
// Modal styling
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight: 'max-content',
  borderRadius: 3,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2.75,
}
export default CloneModal
